// Remove caracteres invisíveis/ocultos comuns ao copiar de PDF ou Word
export const sanitizeText = (value: string): string =>
    value
        .replace(/ /g, ' ')          // non-breaking space → espaço normal
        .replace(/[​-\u200F]/g, '')  // zero-width space, ZWNJ, ZWJ, LRM, RLM
        .replace(/[\u202A-\u202E]/g, '')  // embeddings e overrides direcionais
        .replace(/[⁠-⁯]/g, '')  // word joiner e invisible operators
        .replace(/﻿/g, '')           // BOM / zero-width no-break space
        .replace(/[￹-￻]/g, '')  // interlinear annotation
        .replace(/­/g, '')           // soft hyphen
        .replace(/[-]/g, ''); // controles C1
